<!-- 个人简介 -->
<template>
<div class="info-block">
  <div class="info-detail-content">
    <p v-html="info.label"></p>
  </div>
</div>
</template>
<script>
export default {
  name: 'ZjInfo3',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-detail-content{
  position:relative;
  margin-top:10px;
  //background-color:#eee;
  //border-radius:2px;
}

.info-detail-content p{
  padding:0px;
  font-size:12px;
  font-weight:0;
  text-align: justify;
  text-indent:2em;
  line-height:25px;
  letter-spacing:0px;
  font-family: Arial,"PingFang SC","Hiragino Sans GB",STHeiti,"Microsoft YaHei","WenQuanYi Micro Hei",sans-serif;
  color:#515151;
}
</style>



// WEBPACK FOOTER //
// src/components/module/ZjInfo3.vue